export var IRenderingOption;

(function (IRenderingOption) {
  IRenderingOption["RADIO_BUTTON"] = "radioButton";
  IRenderingOption["CHECK_BOX"] = "checkbox";
  IRenderingOption["DROP_DOWN"] = "dropdown";
})(IRenderingOption || (IRenderingOption = {}));

export var CSSClass;

(function (CSSClass) {
  CSSClass["Goblet"] = "GOBLET";
})(CSSClass || (CSSClass = {}));

export var Type;

(function (Type) {
  Type["Badge"] = "badge";
})(Type || (Type = {}));

export var ItemType;

(function (ItemType) {
  ItemType["Beer"] = "beer";
  ItemType["Default"] = "default";
})(ItemType || (ItemType = {}));